export default __webpack_public_path__ + "static/media/right-sign.e65ab639.svg";